export enum DictonaryKeys {
  football = 'football',
  eventNotFound = 'eventNotFound',
  ticketListError = 'ticketListError',
  soldOut = 'soldOut',
  salesIsNotEnable = 'salesIsNotEnable',
}
